const ChevronRightIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 320 512"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <path d="M285.476 272.971L91.515 466.929c-9.373 9.373-24.569 9.373-33.941 0l-22.627-22.627c-9.373-9.373-9.373-24.569 0-33.941L195.515 256 34.947 95.639c-9.373-9.373-9.373-24.569 0-33.941L57.574 39.071c9.373-9.373 24.569-9.373 33.941 0l193.961 193.958c9.373 9.373 9.373 24.569 0 33.942z" />
  </svg>
);

export default ChevronRightIcon;
